<template>
	<div class="overview-wrap">
		<div id="allmap" class="contact-map"></div>
		<template v-if="!nonContactInfo">
			<div class="contact-align-center">
				<div class="contact-info-title">
					<div class="contact-title-1">
						<!-- 自定义标题 -->
						<slot v-if="'title' in slots" name="title"></slot>
						<span v-else>{{ i18n.t('enterprise.communication-and-connection') }}</span>
					</div>
				</div>
				<div class="contact-info-hr"></div>
				<div class="contact-info-values">
					<div v-if="getPhone" class="contact-value-row">
						<SvgIcons name="fill_phone" class="contact-value-icon" />
						<div class="contact-value-word">
							<span>{{ getPhone }}</span>
						</div>
					</div>
					<div v-if="splitAddressList.main" class="contact-value-row">
						<SvgIcons name="fill_address" class="contact-value-icon" />
						<div class="contact-value-word">
							<span>{{ splitAddressList.main }}</span>
							<template v-if="splitAddressList.rest.length">
								<el-popover placement="top" trigger="hover" popper-class="address-popper">
									<div v-for="(item, index) in splitAddressList.rest" :key="index">
										<span>{{ item }}</span>
									</div>
									<div slot="reference" class="contact-address-more">
										<span>+{{ splitAddressList.rest.length }}</span>
									</div>
								</el-popover>
							</template>
						</div>
					</div>
					<div v-if="getEmail" class="contact-value-row">
						<SvgIcons name="fill_email" class="contact-value-icon" />
						<div class="contact-value-word">
							<span>{{ getEmail }}</span>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script setup>
import { onMounted, computed, useSlots } from 'vue';
import { useCommonData } from '@/hooks';
import { useContactInformation } from '@rebuild/materials/shared/contact_information/useContactInformation';
import i18n from '@/locales';

const slots = useSlots();

const { getPhone, getEmail, getAddressList } = useCommonData();
const splitAddressList = computed(() => {
	const [main, ...rest] = (getAddressList.value || []).map(v => v.address || '').filter(Boolean);
	return {
		main,
		rest
	};
});
const nonContactInfo = computed(() => {
	const { main } = splitAddressList.value;
	return !getPhone.value && !main && !getEmail.value;
});

const { initTencentMap } = useContactInformation();

const refresh = () => {
	let address;
	const { main } = splitAddressList.value;
	if (main) {
		address = main;
	}
	initTencentMap('allmap', address);
};

onMounted(() => {
	refresh();
});
</script>

<style lang="less">
/* 隐藏水印 */
.BMap_cpyCtrl,
.anchorBL {
	display: none;
}

.address-popper {
	&.el-popover {
		max-width: 360px;
		padding: 16px;
		border-radius: 2px;
		background: #fff;
		box-shadow: 1px 4px 16px rgba(0, 0, 0, 0.08);
		border: none;
	}
	&.el-popper[x-placement^='right'] {
		margin-left: 2px;
	}
	&.el-popper[x-placement^='left'] {
		margin-right: 2px;
	}
}
</style>
<style lang="less" scoped>
.overview-wrap {
	border-radius: 2px;
	background: #fff;
	overflow: hidden;

	.contact-map {
		height: 550px;
	}

	.contact-align-left {
		padding: 16px 0;
	}
	.contact-align-center {
		padding: 16px 80px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.contact-info-title {
		flex: none;
	}
	.contact-title-1 {
		max-width: 200px;
		color: #1d2129;

		font-size: 20px;

		font-weight: 500;
		line-height: 28px; /* 140% */
	}
	.contact-info-hr {
		margin: 8px 24px;
		width: 1px;
		height: 72px;
		background: #e5e6eb;
	}
	.contact-info-values {
		.contact-value-row {
			display: flex;
			align-items: center;

			& + .contact-value-row {
				margin-top: 8px;
			}
			.contact-value-icon {
				flex: none;
				font-size: 20px;
			}
			.contact-value-word {
				margin-left: 12px;
				color: #4e5969;

				font-size: 16px;

				font-weight: 400;
				line-height: 24px; /* 150% */
			}
		}
	}

	.contact-address-more {
		margin-left: 8px;
		line-height: 18px;
		display: inline-block;
		vertical-align: 1px;
		padding: 0 10px;
		height: 18px;
		background: #f2f3f5;
		font-size: 0;
		cursor: pointer;

		span {
			color: #4e5969;
			font-size: 12px;
		}
	}
}
</style>
